import axios from 'axios';
import { getLang } from './i18n';

function i18nUrl(filename) {
  const lang = getLang();
  if (lang === "el") {
    const url = `/i18n/el/${filename}`;
    console.log(`Loading Greek canon from ${url}`);
    return url;
  }
  return null;
}

// In production, use relative paths (same origin)
// In development, conditionally bypass proxy if REACT_APP_API_URL is set
export const BACKEND_URL = process.env.REACT_APP_API_URL || process.env.REACT_APP_BACKEND_URL || '';
const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Canon API
export const canonAPI = {
  getParts: () => {
    const url = i18nUrl('canon.parts.json');
    return url ? axios.get(url) : api.get('/canon/parts');
  },
  getTitles: () => api.get('/canon/titles'), // Legacy compatibility
  getArticles: (params = {}) => {
    const url = i18nUrl('canon.articles.json');
    return url ? axios.get(url) : api.get('/canon/articles', { params });
  },
  getArticle: (number) => {
    const url = i18nUrl('canon.articles.json');
    if (url) {
      return axios.get(url).then(response => ({
        data: response.data.find(a => String(a.number) === String(number))
      }));
    }
    return api.get(`/canon/articles/${number}`);
  },
  getPrinciples: () => {
    const url = i18nUrl('canon.principles.json');
    return url ? axios.get(url) : api.get('/canon/principles');
  },
  getGlossary: () => {
    const url = i18nUrl('canon.glossary.json');
    return url ? axios.get(url) : api.get('/canon/glossary');
  },
  search: (query) => api.get('/canon/search', { params: { q: query } }),
  export: () => api.get('/canon/export'),
  getAIRulebook: () => {
    const url = i18nUrl('canon.rulebook.json');
    return url ? axios.get(url) : api.get('/ai-rulebook');
  },
  // Commentary Layer v1.0
  getCommentaryInfo: () => api.get('/canon/commentary'),
  getCommentary: (articleNumber) => api.get(`/canon/commentary/${articleNumber}`),
};

// Chat API
export const chatAPI = {
  send: (question, sessionId = null) =>
    api.post('/chat', { question, session_id: sessionId, language: getLang() }),
};

// Case Analysis API
export const caseAPI = {
  analyze: (domain, facts, narrative) =>
    api.post('/case/analyze', { domain, facts, narrative, language: getLang() }),
};

// Learning API
export const learningAPI = {
  getModules: () => {
    const url = i18nUrl('canon.learning.json');
    return url ? axios.get(url) : api.get('/learning/modules');
  },
  getModule: (id) => {
    const url = i18nUrl('canon.learning.json');
    if (url) {
      return axios.get(url).then(response => ({
        data: response.data.find(m => m.id === id)
      }));
    }
    return api.get(`/learning/modules/${id}`);
  },
  checkAnswer: (moduleId, questionIndex, answerIndex) => {
    const url = i18nUrl('canon.learning.json');
    if (url) {
      return axios.get(url).then(response => {
        const module = response.data.find(m => m.id === moduleId);
        const question = module.quiz_questions[questionIndex];
        const isCorrect = question.correct === answerIndex;
        return {
          data: {
            correct: isCorrect,
            correct_answer: question.options[question.correct],
            explanation: `The correct answer is: ${question.options[question.correct]}`
          }
        };
      });
    }
    return api.post(`/learning/quiz/${moduleId}/check`, null, {
      params: { question_index: questionIndex, answer_index: answerIndex },
    });
  }
};

// Changelog API
export const changelogAPI = {
  get: () => {
    const url = i18nUrl('canon.changelog.json');
    return url ? axios.get(url) : api.get('/changelog');
  },
};

// Simulate API
export const simulateAPI = {
  simulate: (data) => api.post('/canon/simulate', data),
};

// Compare API
export const compareAPI = {
  compare: (data) => api.post('/canon/compare', data),
};

export default api;
